// Usage
// NOTICE: This class works properlly only with any object model instance that has a propery named Id.

// let varName: PArray<ModelObject> = new PArray( this.ObjectInstance );
// let inx = varName.getIndexById( objectid );
// this.ObjectInstance[inx].xxxx = 50;
// var xxx = this.ObjectInstance[inx].someproperty
// varName.pop();
// varName.shift();
// varName.push(newModelObjectItem);
// varName.removeAtIndex(inx);
// varName.removeAtIndex(varName.getIndexById( objectid ));
// varName.Remove(varName[3]);
export class PArray<T> {
    constructor(private array: Array<T>) {}

    public Array(): T[] {
        return this.array;
    } 

    public push(item: T): number {
        return this.array.push(item);
    }

    public length() {
        return this.array.length;
    }

    public remove( item: T ): Array<T> {
        let tmp: Array<any> = new Array();
        for ( var i = 0; i < this.array.length; i++ ) {
            if ( item !== this.array[i] )
                tmp.push(item);
        }
        this.array = tmp;
        return this.array;
    }

    public removAtIndex( index: number ): Array<T> {
        this.array.splice( index, 1 );
        return this.array;
    }

    public join( property: string, separator?: string ):string {
        return this.array.join( separator );
    }

    public split( start?: number, end?: number ): Array<T> {
        return this.array.splice( start, end );
    }

    public shift(): Array<T> {
        this.array.shift();
        return this.array;
    }

    public pop(): Array<T> {
        if (this.array != null && this.array.length > 0)
            this.array.pop();
        return this.array;
    }

    public indexOf(item:T): number {
        if (this.array == null)
            return -1;
        for ( var i = 0; i < this.array.length; i++ ) {
            if ( item === this.array[i] )
                return i;
        }
        return -1;
    }

    public getItemByProperty( propertyName: string, propertyValue: any ): T {
        if (this.array == null)
            return null;
        var result = this.array.find( x => x[propertyName] === propertyValue );
        return (result === undefined) ? null : result;
    }

    public getIndexByProperty(propertyName: string, propertyValue: any): number {
        if (this.array == null)
            return null;

        for ( var i = 0; i < this.array.length; i++ ) {
            if ( this.array[i][propertyName] === propertyValue )
                return i;
        }

        return null;
    }

    public filterByProperty(propertyName: string, propertyValue: any): Array<T> {
        let tempArr: Array<T> = [];
        if (this.array == null)
            return null;
        for (var i = 0; i < this.array.length; i++) {
            if (this.array[i][propertyName] === propertyValue)
                tempArr.push(this.array[i]);
        }

        return tempArr;
    }

    public addIfNotExist(item: T, compareOnPropery: any): Array<T> {
        if (this.array == null)
            return null;
        var temp = null;
        for (var i = 0; i < this.array.length; i++) {
            temp = this.getIndexByProperty(compareOnPropery, item[compareOnPropery]);
            if (temp !== null)
                break;
        }

        if (temp === null)
            this.array.push(item);
        return this.array;
    }
}


// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/shared/packit-array.ts